import { ReelWin } from "./ReelWin";


import { spinData /*, WinObject*/ } from '../server/getServerResposesFun';


import { RespinIndex } from "../config/GlobalVariableConfig";

export class Reels extends ReelWin {

    constructor() {
        super();

    }

    public update() {
        this.updateReelWin()
    }



    public async startPlay(spinStype: string): Promise<[number, number, number?]> {


        console.log("startPlay for Freegame", spinStype, RespinIndex.value, spinData.respins.length);

        let freeGameTrigger = 0;
        let accumulatedsWinAmount = 0;
        let respinWin: number = 0;

        do {
            console.log("startPlay for Freegame", "inside do-while", RespinIndex.value);

            const respinType = RespinIndex.value === 0 ? "reveal" : spinData.respins[RespinIndex.value].type;
            console.log("respinType", respinType);

            if (respinType === "feature_exit" || respinType === "max_win_reached") {
                freeGameTrigger = -1;
                const totalFeatureWin = spinData.respins[RespinIndex.value].accumulatedsWinAmount || 0;
                console.log(`Feature end triggered: ${freeGameTrigger}`);
                RespinIndex.increase();


                if (respinType === "max_win_reached") {
                    // this.resetReelsMaxWin();
                    freeGameTrigger = -2;
                }

                // casinoChannel.publish('showMaxWinDialog');

                return [freeGameTrigger, totalFeatureWin, totalFeatureWin];
            }
            else if (respinType === "reveal" || respinType === "fs_reveal" || respinType === "fs_2_reveal") {


                const isNewSpin: boolean = (respinType === "reveal" || respinType === "fs_reveal" || respinType === "fs_2_reveal");


                if (!isNewSpin) {
                    // reelSpinEmitter.emit('updateMultiplier', spinData.respins[RespinIndex.value - 1].respinMultiplier);
                    // reelSpinEmitter.emit('updateSurgeMeter', spinData.respins[RespinIndex.value - 1].surgeMeter);
                }

                await this.startReels(RespinIndex.value); // Reel spin logic

                // await this.animateJackpotCoins();

                // await this.animateAllWinningSymbols(RespinIndex.value); // this is just marking the winning symbol, not animating symbols here

                if (spinData.respins[RespinIndex.value].winAmount > 0) { // that means this ends the spin presentation

                    // this.endTopReelGridAnticipation();
                    // this.endBottomReelGridAnticipation();

                    await new Promise(resolve => setTimeout(resolve, 500));
                    await this.playTransitionBeforeWin();

                    const currentRespin = spinData.respins[RespinIndex.value];
                    if (!currentRespin?.isMaxwinJackpotWon) {
                        await this.animateAllWinningSymbols();
                        //this.winCollectionMeter.tint = "0x555555";

                    }
                }

                if (isNewSpin) {
                    respinWin = 0;
                    // this.setAccWinValue(0);
                }

                respinWin += spinData.respins[RespinIndex.value].winAmount;

                accumulatedsWinAmount = spinData.respins[RespinIndex.value].accumulatedsWinAmount;

                // Check for fs_battleRespin sequence end in free games
                if ((spinStype === "FREEGAME") &&
                    (respinType === "fs_reveal" || respinType === "fs_2_reveal") &&
                    (spinData.respins[RespinIndex.value + 1]?.type !== "max_win_reached")
                ) {

                    RespinIndex.increase();

                    return [freeGameTrigger, respinWin, accumulatedsWinAmount];
                }
            }

            if (spinData.respins[RespinIndex.value].featureData?.coinInfo.spinLeft?.value === 0) {
                return [freeGameTrigger, respinWin, accumulatedsWinAmount];
            }
            RespinIndex.increase();
            console.log(`HNW Respin is done for index ${RespinIndex.value}`);

        } while (RespinIndex.value < spinData.respins.length);

        return [freeGameTrigger, accumulatedsWinAmount];  // Return final result if loop completes without early return
    }

}
